import { useDispatch, useSelector } from 'react-redux'
import { useLocalization } from '../../Hooks/useLocalization'
import {
  type AvailableDestinationViews,
  setDestinationView,
  adminViews,
  secureViews,
} from '../../Store/InterfaceSlice'
import { type RootState } from '../../Store/Store'
import { useCallback } from 'react'

interface MenuItemProps {
  view: AvailableDestinationViews
  relatedViews: AvailableDestinationViews[]
  localizationText: string
}

export function MenuItem({
  view,
  relatedViews,
  localizationText,
}: MenuItemProps) {
  const dispatch = useDispatch()
  const localization = useLocalization('top-menu')
  const activeView = useSelector(
    (state: RootState) => state.interface.activeView
  )
  const navigate = useCallback(() => {
    dispatch(
      setDestinationView({
        destinationView: view,
      })
    )
  }, [dispatch, view])
  const user = useSelector((state: RootState) => state.authentication.user)
  if ((adminViews as unknown as string[]).includes(view)) {
    if (user?.isAdmin !== true) return null
  } else if ((secureViews as unknown as string[]).includes(view)) {
    if (user == null) return null
  }
  return (
    <div
      className={`menu-item ${
        relatedViews.includes(activeView) ? 'active' : ''
      }`}
      onClick={navigate}
    >
      {localization.text(view, localizationText)}
    </div>
  )
}
